<script setup>
import BaseChatMessage from './BaseChatMessage.vue'

defineProps({
  content: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <BaseChatMessage variant="human">
    {{ content }}
  </BaseChatMessage>
</template>
